import React from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {Footer} from "../../_common/components/Footer/Footer";

export const UsersClientActionsFooter = () => {
  const {count} = useSelector(
    (state) => ({count: state.usersClientActions.totalCount}),
    shallowEqual
  );

  return <Footer count={count}/>
};
